// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var PayloadstagingDocumentType;
(function (PayloadstagingDocumentType) {
    PayloadstagingDocumentType["UNKN"] = "UNKN";
    PayloadstagingDocumentType["SRF"] = "SRF";
    PayloadstagingDocumentType["COR"] = "COR";
    PayloadstagingDocumentType["INC"] = "INC";
    PayloadstagingDocumentType["CLM"] = "CLM";
    PayloadstagingDocumentType["ENR"] = "ENR";
    PayloadstagingDocumentType["PA"] = "PA";
    PayloadstagingDocumentType["AOB"] = "AOB";
    PayloadstagingDocumentType["OTHER"] = "OTHER";
})(PayloadstagingDocumentType || (PayloadstagingDocumentType = {}));
//# sourceMappingURL=payloadstagingDocumentType.js.map